/* TODO: Remove this when the backend stops sending dummy board URLs,
         as locationless boards will be handled by the backend and this check will no longer be needed.
 */
export const isDummyBoardUrl = (url: string | undefined): boolean =>
	Boolean(url?.endsWith('/browse/DummyJiraBoard'));
